import { getGenericHospitalPhotoId } from '@components/app/TrialSummaryCard/consts'
import { getPrioritizedImages } from '@components/app/TrialSummaryCard/getPrioritizedImages'
import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import calculateStringValue from '@lib/utilities/number/calculateStringValue'
import type { TrialForSummaryCard } from '@modules/trials/types/TrialForSummaryCard'

export default function TrialSiteLocationImage({
  trial,
}: {
  trial: TrialForSummaryCard
}) {
  const trialLocationsMonetized = trial.trialLocations
    .filter((tl) => tl.city && tl.state)
    .sort(
      (a, b) =>
        (b.managingTrialPros?.length ?? 0) - (a.managingTrialPros?.length ?? 0),
    )

  const trialLocationText = [
    trialLocationsMonetized[0]?.city,
    trialLocationsMonetized[0]?.state,
  ]
    .filter((v) => typeof v === 'string')
    .join(', ')

  const trialDigitOffset = calculateStringValue(trial.slug!)
  // sort so we should a random site, then a random city, then a random state
  const [mostRelevantImage] = getPrioritizedImages(
    trialLocationsMonetized[0]?.images ?? [],
    trialDigitOffset,
  )

  const imageToRender =
    mostRelevantImage?.externalId ?? getGenericHospitalPhotoId(trialDigitOffset)

  return (
    <div className='relative z-0 size-full overflow-clip rounded-t-xl'>
      <div className='size-full overflow-clip'>
        <CloudflareImage
          alt={trialLocationText}
          className='size-full opacity-90'
          fit='cover'
          height={202}
          imageId={imageToRender}
          width={384}
        />
      </div>
      <div className='absolute left-0 top-0 size-full bg-gradient-to-t from-white' />
    </div>
  )
}
